import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeSupportDrawer } from '../../redux/slices/supportDrawerSlice';
import SupportAndFeedback from './SupportAndFeedback';

function GlobalSupportDrawer() {
  const dispatch = useDispatch();
  const { isOpen, supportType } = useSelector(state => state.supportDrawer);

  return (
    <SupportAndFeedback
      isDrawerOpen={isOpen}
      setIsDrawerOpen={open => {
        if (!open) {
          dispatch(closeSupportDrawer());
        }
      }}
      supportType={supportType}
    />
  );
}

export default GlobalSupportDrawer;
